import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import Select from 'react-select'
import WINWorker from "../../Services/WINWorker";

export default function ProfileItem(props) {
    const {t, i18n} = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [profile, setProfile] = useState({
        edit_employees: '',
        edit_profile: '',
        id: 0,
        image: '',
        name: '',
        view_profile: ''
    })
    const [stats, setStats] = useState({
        profile_views: '-',
        project_views: '-',
        website_views: '-',
    });
    const [reportingPeriods, setReportingPeriods] = useState([
        {value: 'alltime', label: 'All Time'},
    ]);

    console.log('props', props);

    const handleChange = () => {
        setfilterOpen(!filterOpen);
        const btn_el = document.querySelector(".js-btn-filter");
        const panel_el = document.querySelector(".js-filters-panel");


        btn_el.classList.toggle('open');
        panel_el.classList.toggle('filters-open');


    };

    const handleSelect = (date) => {
        console.log(date); // native Date object
    }

    const selectionRange = {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    }

    const getProfileStatsByRange = (profile, start_date, end_date) => {
        WINWorker.getProfileStatsByRange(profile.id, props.profileType, start_date, end_date)
            .then(response => {
                console.log('response', response);
                setStats(response);
            })
            .catch(error => {
                console.log('error', error);
            });
    }

    let initProfileStats = () => {
        setProfile(props.profile);
        if (props.profile.reporting_periods) {
            setReportingPeriods(props.profile.reporting_periods.unshift({
                value: 'alltime',
                label: 'All Time',
                start_date: 'ALL',
                end_date: 'ALL'
            }));
        }
        getProfileStatsByRange(props.profile, 'ALL', 'ALL');
    }


    const refineReportingPeriod = (period) => {
        console.log('period',)
        getProfileStatsByRange(props.profile, period.start_date, period.end_date);
    }

    let initalReportingValue = reportingPeriods[0];

    const customStyles = {
        indicatorSeparator: () => ({
            display: 'none;'
        }),

    }

    useEffect(
        () => {
            initProfileStats(props);
        },
        [props]
    );

    return (
        <li>
            <div className="team-content-body">
                <div className="team-content">
                    <img
                        src={profile.image}
                        alt="Profile Picture" width="153" height="153"/>
                    <span className="profile__name">
                   {profile.name}
                  </span>
                </div>
                <div className="dashboard-metric-list">
                    <div className="metric-stat">
                        <p>{stats.profile_views.toLocaleString()}</p>
                        <h6>Profile Views</h6>
                    </div>
                    <div className="metric-stat">
                        <p>{stats.project_views.toLocaleString()}</p>
                        <h6>Project Views</h6>
                    </div>
                    {props.profileType !== "USER" &&
                        <div className="metric-stat">
                            <p>{stats.website_views.toLocaleString()}</p>
                            <h6>Website Views</h6>
                        </div>
                    }
                    <div className="metric-stat-range-break"></div>
                    <div className="metric-stat-range dashboard-profile-links">
                        <ul className="list-team">
                            <li>Filter By:</li>
                            <li className="link">
                                <Select className="metric-stat-range-select" classNamePrefix="range-select"
                                        classNames={{
                                            control: (state) =>
                                                state.isFocused ? 'stat-range-select-focused' : 'stat-range-select',
                                        }} styles={customStyles} menuPlacement="bottom"
                                        options={props.profile.reporting_periods}
                                        defaultValue={initalReportingValue} onChange={selectedOption =>
                                    refineReportingPeriod(selectedOption)
                                }/>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="dashboard-profile-links">
                <ul>
                    {profile.edit_profile !== "NONE" && (
                        <li><a href={profile.edit_profile}>Edit Profile</a></li>
                    )}
                    <li><a href={profile.view_profile}>View Profile</a></li>
                    {props.profileType !== "USER" && profile.edit_employees !== "NONE" && (
                        <li>
                            <a href={profile.edit_employees}>Manage Employees</a>
                        </li>
                    )}
                </ul>
            </div>
        </li>
    );
}
